import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import './Recording.css';
import Enums from '../../constants/Enums';
import States from '../../constants/States';

const Recording = ({
  recordingDetails,
}) => {
  const { recordButtonState, setRecordButtonState } = recordingDetails;
  const { recordingDetailsStates } = States;
  const { recordingDetailsEnum } = Enums;

  const suspendRecording = () => {
    setRecordButtonState(recordingDetailsStates.REQUEST_SUSPEND);
  };
  const resumeRecording = () => {
    setRecordButtonState(recordingDetailsStates.REQUEST_RUSUME);
  };

  switch (recordButtonState) {
    case recordingDetailsStates.RECORDING:
      return (
        <div className="recording-details-container">
          <Button id="stop-recording-btn" onClick={suspendRecording}>
            {recordingDetailsEnum.RECORDING_LABEL}
          </Button>
          <div className="recording-details-message">
            {recordingDetailsEnum.RECORDING_MESSAGE}
          </div>
        </div>
      );
    case recordingDetailsStates.SUSPENDED:
      return (
        <div className="recording-details-container">
          <Button id="start-recording-btn" onClick={resumeRecording}>
            {recordingDetailsEnum.SUSPENDED_LABEL}
          </Button>
          <div className="recording-details-message">
            {recordingDetailsEnum.SUSPENDED_MESSAGE}
          </div>
        </div>
      );
    case recordingDetailsStates.WAITING_SUSPEND:
      return (
        <div className="recording-details-container">
          <div className="loading-wheel">
            <i className="fas fa-spinner loading-spinner spin-animation waitSpinner" />
          </div>
          <div className="recording-details-message">
            {recordingDetailsEnum.WAIT_SUSPEND_MESSAGE}
          </div>
        </div>
      );
    case recordingDetailsStates.WAITING_RESUME:
      return (
        <div className="recording-details-container">
          <div className="loading-wheel">
            <i className="fas fa-spinner loading-spinner spin-animation waitSpinner" />
          </div>
          <div className="recording-details-message">
            {recordingDetailsEnum.WAIT_RESUME_MESSAGE}
          </div>
        </div>
      );
    case recordingDetailsStates.ERROR_SUSPEND:
      return (
        <div className="recording-details-container">
          <Button id="stop-recording-btn" onClick={suspendRecording}>
            {recordingDetailsEnum.RECORDING_LABEL}
          </Button>
          <div className="recording-details-message">
            {recordingDetailsEnum.ERROR_SUSPEND}
          </div>
        </div>
      );
    case recordingDetailsStates.ERROR_RESUME:
      return (
        <div className="recording-details-container">
          <Button id="start-recording-btn" onClick={resumeRecording}>
            {recordingDetailsEnum.SUSPENDED_LABEL}
          </Button>
          <div className="recording-details-message">
            {recordingDetailsEnum.ERROR_RESUME}
          </div>
        </div>
      );
    case recordingDetailsStates.EMPTY:
      return (
        <div className="recording-details-container">
          <div className="recording-details-message">
            {recordingDetailsEnum.EMPTY_MESSAGE}
          </div>
        </div>
      );
    default:
      return (
        <div className="recording-details-container">
          <div className="recording-details-message">
            {recordingDetailsEnum.EMPTY_MESSAGE}
          </div>
        </div>
      );
  }
};

Recording.propTypes = {
  recordingDetails: PropTypes.shape().isRequired,
};

export default Recording;
